module.exports = __webpack_public_path__ + "static/media/waalatext.c69c1cb4.png";